import React, { useState } from 'react';
import { Tooltip } from 'antd';
import style from './TooltipNew.module.scss';

interface IProps {
	children: React.ReactNode;
}

export const TooltipForTextNew: React.FC<IProps> = React.memo(({ children }) => {
	const [isVisibleTooltip, setIsVisibleTooltip] = useState<boolean>(false);

	const handleOnMouse = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.currentTarget.clientWidth < e.currentTarget.scrollWidth) {
			setIsVisibleTooltip(true);
		}
	};

	return (
		<Tooltip overlayClassName={style.container} visible={isVisibleTooltip} title={children} placement="topLeft">
			<div className={style.text} onMouseEnter={handleOnMouse} onMouseOut={() => setIsVisibleTooltip(false)}>
				{children}
			</div>
		</Tooltip>
	);
});
